import {
  Box,
  Grid,
  GridColumn,
  RadioButton,
  Text
} from "@modernatx/ui-kit-react";
import React from "react";

import { CreditCardBrand, PaymentMethod } from "@/types/PaymentMethod";
import { getCardName } from "@/utils/InvoicePay";

interface PaymentMethodOptionProps {
  paymentMethod: PaymentMethod;
}

function getPaymentDetails(
  brand: CreditCardBrand | undefined,
  bankName: string | undefined
) {
  const paymentInfos = [getCardName(brand), bankName]
    .filter((paymentInfo) => paymentInfo)
    .join(" - ");
  return { name: paymentInfos };
}

export const PaymentMethodOptionRadioBtn: React.FC<
  PaymentMethodOptionProps
> = ({ paymentMethod }) => {
  const { brand, bankName, lastFour, expirationDate, billingName } =
    paymentMethod.paymentMethodInfo;
  const details = getPaymentDetails(brand, bankName);

  const PaymentMethodLabel = (
    <Grid>
      <GridColumn fillGapStart={true}>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Text variant="body-1-bold">{details.name}</Text>
          <Text>ending in</Text>
          <Text variant="body-1-bold">{lastFour}</Text>
        </Box>
      </GridColumn>
      <GridColumn fillGapStart={true}>
        {billingName && <Text>{billingName}</Text>}
      </GridColumn>
      <GridColumn fillGapStart={true}>
        {brand && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Text>Expires</Text>
            <Text variant="body-1-regular">{expirationDate}</Text>
          </Box>
        )}
      </GridColumn>
    </Grid>
  );

  return (
    <RadioButton key={lastFour} label={PaymentMethodLabel} value={lastFour} />
  );
};
